export const getIsEvo = (baseUrl) => {
    return (baseUrl || "").includes("evo");
};
export const sanitizeBaseUrl = (baseUrl) => {
    return baseUrl.endsWith("/api") ? baseUrl.slice(0, -4) : baseUrl;
};
//# sourceMappingURL=evo.js.map